import React from 'react';
import TablaConfgFechaspc from '../components/impuestoprodu/tablaConfigFecha';

function ConfVechapro() {
  return (
 <TablaConfgFechaspc/>
  );
}

export default ConfVechapro;




// WEBPACK FOOTER //
// ./src/pages/configfechaproc.js